import styled, { css } from 'styled-components';

export const DateInputWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    min-width: 140px;

    @media (max-width: ${theme.breakpoints.sm}) {
      min-width: auto;
      width: 100%;
    }
  `}
`;

export const DateInputContainer = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 12px;
    padding: 12px 16px;
    position: relative;
    transition: border-color 0.2s ease;
    height: 56px;
    width: 180px;

    &:hover {
      border-color: ${theme.v2.colors.neutral.lowLight};
    }

    &:focus-within {
      border-color: ${theme.v2.colors.brand.primaryMedium};
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      width: 100%;
      padding: 10px 12px;
      height: auto;
      min-height: 48px;
      gap: 8px;
    }
  `}
`;

export const CalendarIcon = styled.div`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    flex-shrink: 0;
  `}
`;

export const DateInputContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`;

export const DateInputLabel = styled.label`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowLight};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const DateInputValue = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const DateInputField = styled.input`
    border: none;
    cursor: pointer;
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;

    &::-webkit-calendar-picker-indicator {
      cursor: pointer;
      height: 100%;
      position: absolute;
      width: 100%;
    }
`;
